import { AxiosError, AxiosInstance } from "axios";
import { endSession } from "../utils/session";

/**
 * Signs the user out when the API says their token ran out.
 *
 * Both backends this portal talks to answer 401 for an expired token
 * (SurgoAdminApi since admin tokens gained a 24h expiry; the derin admin API from
 * its global auth guard) and keep 403 for "authenticated but not allowed".
 * Without this the screens render empty behind an error toast while the user
 * still looks signed in, because ProtectedRoute only ever checked that the cookie
 * existed.
 *
 * Attach to authenticated clients only — the no-auth ones serve sign-in itself.
 */
export const attachSessionExpiryHandler = (instance: AxiosInstance): void => {
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        endSession();
      }

      return Promise.reject(error);
    }
  );
};
